/* eslint-disable @typescript-eslint/no-unused-vars */
// @ts-nocheck
/**
 * This file Copyright (c) 2010-2021 Magnolia International
 * Ltd.  (http://www.magnolia-cms.com). All rights reserved.
 *
 *
 * This program and the accompanying materials are made
 * available under the terms of the Magnolia Network Agreement
 * which accompanies this distribution, and is available at
 * http://www.magnolia-cms.com/mna.html
 *
 * Any modifications to this file must keep this entire header
 * intact.
 *
 */
// Auto generated file, don't change manually

import type {
  Asset,
  Rendition
} from '../../../../magnolia/lib/MagnoliaAsset';
import {
  transformNode,
  transformResults
} from '../../../../magnolia/lib/MagnoliaPropertyHelper';

export interface thumbnailStruct {
  image ? : Asset;
}
export default interface Media {
  media: Asset;
  enableAutoplay ? : boolean;
  enableFullscreen ? : boolean;
  enableDownload ? : boolean;
  muted ? : boolean;
  disablePicInPic ? : boolean;
  inlineOnly ? : boolean;
  playback: string;
  thumbnail ? : Array < thumbnailStruct > ;
  width ? : string;
  dataABId ? : string;
  metadata ? : any;
}

export const Props = {
  media: Object as() => Asset,
  enableAutoplay: Boolean,
  enableFullscreen: Boolean,
  enableDownload: Boolean,
  muted: Boolean,
  disablePicInPic: Boolean,
  inlineOnly: Boolean,
  playback: String,
  thumbnail: Array as() => Array < thumbnailStruct > ,
  width: String,
  dataABId: String,
  metadata: Object,
}

export const WrapperProps = {
  media: Object as() => Asset,
  enableAutoplay: Boolean,
  enableFullscreen: Boolean,
  enableDownload: Boolean,
  muted: Boolean,
  disablePicInPic: Boolean,
  inlineOnly: Boolean,
  playback: String,
  thumbnail: Object,
  width: String,
  dataABId: String,
  metadata: Object,
}

export class MediaBuilder {
  static build(props: any) {
    props = transformNode(JSON.parse(JSON.stringify(props)));
    class MediaInstance implements Media {
      media: Asset;
      enableAutoplay ? : boolean;
      enableFullscreen ? : boolean;
      enableDownload ? : boolean;
      muted ? : boolean;
      disablePicInPic ? : boolean;
      inlineOnly ? : boolean;
      playback: string;
      thumbnail ? : Array < thumbnailStruct > ;
      width ? : string;
      dataABId ? : string;
      metadata ? : any;

      constructor(props: any) {
        Object.assign(this, props);

        if (typeof this.media === 'object') {
          this.media = {
            ...this.media,
            link: this.media['@link'],
            name: this.media['@name'],
            path: this.media['@path'],
          };
        } else {
          this.media = null as any;
        }
        if (this.thumbnail) {
          this.thumbnail = Object.entries(this.thumbnail)
            .filter((pair: [string, any]) => pair[0].match(new RegExp('^' + 'thumbnail' + '[0123456789]+')))
            .map((pair: [string, any]) => ({
              ...pair[1]
            }));
          for (let i1 = 0; i1 < this.thumbnail.length; i1++) {
            if (this.thumbnail[i1]) {
              if (typeof this.thumbnail[i1].image === 'object') {
                this.thumbnail[i1].image = {
                  ...this.thumbnail[i1].image,
                  link: this.thumbnail[i1].image['@link'],
                  name: this.thumbnail[i1].image['@name'],
                  path: this.thumbnail[i1].image['@path'],
                };
              } else {
                this.thumbnail[i1].image = null as any;
              }
            }
          }
        } else {
          this.thumbnail = null as any;
        }
      }
    }
    return new MediaInstance(props);
  }
}
